import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DsModule } from '@levelaccess/design-system';
import { IWorkspace } from '../../../../../../shared/interfaces/workspace.interface';
import { CommonPipesModule } from '../../../../shared/common-pipes.module';
import { SharedTenantsModule } from '../../../../admin/tenants/shared-tenants.module';

@Component({
  selector: 'app-add-workspace-modal',
  templateUrl: './add-workspace-modal.component.html',
  styleUrl: './add-workspace-modal.component.scss',
  imports: [DsModule, CommonPipesModule, SharedTenantsModule],
})
export class AddWorkspaceModalComponent {
  @Input() tenantId: string;

  constructor(public modal: NgbActiveModal) {}

  onWorkspaceAdded(workspace: IWorkspace): void {
    this.modal.close(workspace);
  }

  onBulkCreated(): void {
    this.modal.close();
  }

  onCancel(): void {
    this.modal.dismiss();
  }
}
